import React, {ReactNode} from "react";
import {DatePicker, Form, Input, InputNumber, Select} from "antd";

type EditableFunc = (record: any) => boolean

export enum EditType {
    text = 'text',
    select = 'select',
    date = 'date',
    time = 'time',
    dateRange = 'dateRange',
    timeRange = 'timeRange',
    dateTimeRange = 'dateTimeRange',
    digit = 'digit',
}

export interface EditableColumnType {
    editable?: boolean | EditableFunc
    editIndex?: string
    editRules?: any[]
    editType?: string
    editValueEnum?: EditValueEnum
    editComponentProps?: any
    editRender?: (record: any) => ReactNode
}

interface EditValueEnum {
    [key: string]: {
        text: string
    }
}

export function EditCellComponent(props: any) {
    const {
        children,
        editable,
        clickable = false,
        editing = false,
        editType,
        editRules,
        editValueEnum,
        editRender,
        dataIndex,
        rowIndex,
        record,
        className,
        editComponentProps,
        onEditChange,
        onEditClick,
        ...cellProps
    } = props;

    function renderItem() {
        if (editRender) {
            return editRender(record)
        } else if (editType === EditType.text) {
            return (
                <Input onPressEnter={(e: any) => onEditChange?.(dataIndex, e.target.value)} {...editComponentProps}/>
            )
        } else if (editType === EditType.digit) {
            return (
                <InputNumber
                    onPressEnter={(e: any) => onEditChange?.(dataIndex, e.target.value)}  {...editComponentProps}
                    style={{width: '100%'}}/>
            )
        } else if (editType === EditType.select) {
            const keys = Object.keys(editValueEnum)
            return (
                <Select {...editComponentProps} >
                    {keys.map(key => (
                        <Select.Option key={key} value={key}>{editValueEnum[key].text}</Select.Option>
                    ))}
                </Select>
            )
        } else if (editType === EditType.date) {
            return (
                <DatePicker/>
            )
        }
    }

    let childNode = children;
    if (editable) {
        if (editing) {
            childNode = (
                <div>
                    <Form.Item name={dataIndex} rules={editRules} style={{margin: 0}}>
                        {renderItem()}
                    </Form.Item>
                </div>
            )
        } else if (clickable) {
            childNode = (
                <div className={'editable-cell-value-wrap'} onClick={() => onEditClick?.()}>{childNode}</div>
            )
        }
    }

    const combineClassName = [className].join(' ');

    return (
        <td {...cellProps} className={combineClassName}>{childNode}</td>
    )
}

